import webBackApi from '../../api/webBackApi';

export const checkCameraActive = async (feedId) => {
  try {
    const response = await webBackApi.get(`/api/s3-images/check-last-24-hours/${feedId}`);
    return response.data.hasRecords;
  } catch (error) {
    console.error("Error checking camera status:", error);
    return false;
  }
}
